import { Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { ClientRoute } from 'routes/client'
import { rem } from 'theme/materialUITheme'

const useStyles = makeStyles((theme: Theme) => ({
  challengeTitle: {
    color: '#373D40',
    fontSize: rem(32),
    fontWeight: 500,
  },
  challengeDescription: {
    color: '#373D40',
    fontSize: rem(16),
    fontWeight: 500,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
  leaderboardScore: {
    padding: `${rem(8)} ${rem(16)}`,
    backgroundColor: '#F5F5F9',
    borderRadius: rem(60),
    width: 'fit-content',
  },
  link: {
    textDecoration: 'none',
    color: 'initial',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}))

interface Props {
  challengeDescription: {
    challengeDuration: string
    challengeId: string
    challengeLocationEligibility: string
    challengeName: string
    challengeType: string
    challengeVisibility: string
    targetScore: number
    userCurrentScore: number
  }
}

const RoundsDescriptionContainer = ({
  challengeDescription: {
    challengeDuration,
    challengeId,
    challengeLocationEligibility,
    challengeName,
    challengeType,
    challengeVisibility,
    targetScore,
    userCurrentScore,
  },
}: Props) => {
  const intl = useIntl()
  const classes = useStyles()
  return (
    <div className={classes.headerContainer}>
      <Typography className={classes.challengeTitle}>
        {intl.formatMessage({ id: 'strings.rounds' })} /{' '}
        <Link className={classes.link} to={ClientRoute.ADMIN_CHALLENGE(challengeId)} target="_blank">
          {challengeName}
        </Link>
      </Typography>
      <div style={{ display: 'flex', flexDirection: 'column', gap: rem(16) }}>
        <div>
          <Typography className={classes.challengeDescription}>{`Type: ${challengeType}`}</Typography>
          <Typography className={classes.challengeDescription}>{`Target: ${targetScore}`}</Typography>
          <Typography
            className={classes.challengeDescription}
          >{`Where challenge can be performed: ${challengeLocationEligibility}`}</Typography>
          <Typography
            className={classes.challengeDescription}
          >{`Visibility targeting: ${challengeVisibility}`}</Typography>
          <Typography className={classes.challengeDescription}>{`Duration: ${challengeDuration}`}</Typography>
        </div>
        <div className={classes.leaderboardScore}>
          <Typography
            className={`${classes.challengeDescription}`}
            style={{ fontSize: rem(18) }}
          >{`Leaderboard score: ${userCurrentScore}`}</Typography>
        </div>
      </div>
    </div>
  )
}

export default RoundsDescriptionContainer
